import { graphql, HttpResponse } from 'msw'
import {
  MaritalStatus,
  type EnrollmentJointFinancesData,
  type EnrollmentJointFinancesSubmitOutput,
} from '../../../../models'
import { EnrollmentTaxFilingStatusType, PersonalNetWorthRange } from '../../../../models/enrollment/enrollment'

export const getEnrollmentJointFinancesDataMock: EnrollmentJointFinancesData = {
  errors: [],
  isError: false,
  accountType: 'JOINT_COMMUNITY_PROPERTY',
  activePerson: {
    applicationId: '305802305',
    progress: 40,
    path: '/enrollment/joint/finances',
    taxFilingStatus: EnrollmentTaxFilingStatusType.Single,
    maritalStatus: MaritalStatus.SINGLE,
    personalAnnualGrossIncome: 100000,
    personalNetWorthRange: PersonalNetWorthRange.Between_100KAnd_200K,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    isInitiator: false,
  },
}

export const submitEnrollmentJointFinancesDataMock: EnrollmentJointFinancesSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/investment-goals',
  },
}

export const mockGetEnrollmentJointFinancesData = graphql.mutation('getEnrollmentJointFinancesData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointFinancesDataMock } })
})

export const mockSubmitEnrollmentJointFinancesData = graphql.mutation('submitEnrollmentJointFinancesData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointFinancesDataMock } })
})

export const mockEnrollmentJointFinances = [mockGetEnrollmentJointFinancesData, mockSubmitEnrollmentJointFinancesData]
